/**
 * 외부 링크 href 안전화: javascript:·data: 등 비정상 scheme 차단
 * @param {string} url
 * @returns {string|null} 안전한 URL 또는 null
 */
export function toExternalUrl(url) {
  const trimmed = (url || '').trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return null; // javascript:, data: 등 차단
  return `https://${trimmed}`;
}
